/**
 * InfoBoxCriteriaItem
 */
import React from 'react';
import { Link as LinkBase, Icon } from 'ui-component-library/base';
/** Main description for this component. */
var InfoBoxCriteriaItem = function (_a) {
    var heading = _a.heading, subHeading = _a.subHeading, _b = _a.headingLevel, headingLevel = _b === void 0 ? 'h3' : _b, linkText = _a.linkText, url = _a.url, _c = _a.LinkComponent, LinkComponent = _c === void 0 ? LinkBase : _c, children = _a.children;
    var Heading = headingLevel;
    var Link = LinkComponent;
    return (React.createElement("div", { className: "mt-16" },
        React.createElement(Heading, { className: "mb-4 mt-10 text-xl flex justify-between" },
            React.createElement("span", { className: "font-bold" }, heading),
            subHeading && React.createElement("span", null, subHeading)),
        children,
        url && linkText && (React.createElement("div", { className: "flex justify-end my-4" },
            React.createElement(Link, { to: url, className: "text-xl text-teal hover:underline" },
                linkText,
                React.createElement(Icon, { icon: "arrow", size: 1.25, "aria-hidden": true, className: "ml-4" }))))));
};
export default InfoBoxCriteriaItem;
